import { type CSSProperties, type ReactNode, useId } from 'react';

import styles from './softened-artwork.module.css';

/** Soften white artwork surfaces in light mode without tinting blue or black. */
export default function SoftenedArtwork({ children, className }: { children: ReactNode; className?: string }) {
  const filterId = useId();

  return (
    <>
      <svg width="0" height="0" className="absolute pointer-events-none" aria-hidden="true" focusable="false">
        <defs>
          <filter id={filterId} colorInterpolationFilters="sRGB" x="0" y="0" width="100%" height="100%">
            {/* White yields an opaque mask; blue and black yield zero. The ramp
                preserves shaded edges instead of cutting out a hard color key. */}
            <feColorMatrix
              in="SourceGraphic"
              type="matrix"
              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  10 10 -10 0 -8"
              result="lightSurfaces"
            />
            <feFlood floodColor="#DDDDDD" result="surfaceColor" />
            <feComposite in="surfaceColor" in2="lightSurfaces" operator="in" result="mutedSurfaces" />
            {/* Reapply the original alpha once, keeping antialiased edges transparent. */}
            <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0 1" result="opaqueSource" />
            <feComposite in="mutedSurfaces" in2="opaqueSource" operator="over" result="recolored" />
            <feComposite in="recolored" in2="SourceAlpha" operator="in" />
          </filter>
        </defs>
      </svg>
      <div className={`${className ?? ''} ${styles.artwork}`} style={{ '--artwork-white-filter': `url("#${filterId}")` } as CSSProperties}>
        {children}
      </div>
    </>
  );
}
